export default "__VITE_ASSET__Bl1XkBd___"